import { IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { AutoTopCv } from './autoTopCv';

import {IAutoApplyVacancy, IAutoTopCv} from './smart-services.interface';


export class SmartServicesService {
  static $inject = [
    '$http',
    'GmcApi'
  ];

  constructor( private $http: IHttpService,
               private gmcApi: GmcApi ) {
  }

  getMyService( params ): IPromise<any> {
    const { id } = params;
    return this.$http.get<any>(`${this.gmcApi.smartServices.getMyService}/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  getMyServices( params ): IPromise<any> {
    const { type, page } = params;
    return this.$http.get<any>(`${this.gmcApi.smartServices.getMyServices}/${type}/${page}?limit=3`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  getMyServicesTypes(): IPromise<any> {
    return this.$http.get<any>(this.gmcApi.smartServices.getMyServicesTypes)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  autoTopCv( data ): IPromise<any> {
    return this.$http.post<any>(this.gmcApi.smartServices.autoTopCv, data)
      .then(( res ) => {
        return res.data;
      })
      .catch(( err ) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  topCv(currency): IPromise<any> {
    return this.$http.post(this.gmcApi.smartServices.topCv, currency)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw  new Error(err.data ? err.data.text: 'Error');
      });
  }

  preApplyCheck( id?, params? ): IPromise<any>  {
    return this.$http.get<any>(`${this.gmcApi.smartServices.preApplyCheck}`, params).then((res) => {
      return res.data;
    }).catch((err) => {
      throw  new Error(err.data ? err.data.text: 'Error');
    });
  }

  presendCvCheck(params?): IPromise<any> {
    return this.$http.post<any>(`${this.gmcApi.smartServices.preSendCVCheck}`, params)
      .then((res) => {
        return res.data;
      }).catch((err) => {
        throw new Error(err.data ? err.data.text: 'Error');
      });
  }

  applyVacancy( id, currency ): IPromise<any> {
    return this.$http.post<any>(this.gmcApi.smartServices.applyVacancy + id,
      {currency: currency}
      )
      .then((res) => {
        return res.data;
      })
      .catch(( err ) => {
        console.log(err);
        throw new Error(err.data.isError ? (err.data.text.text ? err.data.text.text : err.data.text) : 'Error');
      });
  }

  sendCV(params): IPromise<any> {
    return this.$http.post<any>(this.gmcApi.smartServices.sendCv, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  sendCVToUser(params): IPromise<any> {
    return this.$http.post<any>(this.gmcApi.smartServices.autoSendCVToUser, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  sendCVToUsers(params): IPromise<any> {
    return this.$http.post<any>(this.gmcApi.smartServices.autoSendCVToUsers, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  topVacancy(params): IPromise<any> {
    return this.$http.post<any>(this.gmcApi.smartServices.topVacancy, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  autoTopVacancy(params): IPromise<any> {
    return this.$http.post(this.gmcApi.smartServices.autoTopVacancy, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  autoApplyVacancy(autoApplyVacancyData: IAutoApplyVacancy): IPromise<any> {
    return this.$http.post(this.gmcApi.smartServices.autoApplyVacancy, autoApplyVacancyData)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error')
      });
  }

}



// WEBPACK FOOTER //
// ./app/core/services/smart-services/smart-services.service.ts